export default __webpack_public_path__ + "static/media/logo192x192.09f0b732.png";